<template>
  <div class="text-center">
    <h1 class="text-2xl font-bold">Page Not Found</h1>
    <p>
      Please check the URL or
      <NuxtLink class="text-primary cursor-pointer hover:underline" to="/"
        >return to the home page</NuxtLink
      >.
    </p>
  </div>
  <ErrorStackTrace :error="error" />
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";
defineProps<{ error: NuxtError }>();
</script>
